<template>
  <div class="course-result-calendar-contain">
    <section class="calendar-filter clearfix">
      <div class="calendar-filter-lf">
        <div class="filter-lf-top">
          <el-button type="primary" :loading="downLoading" @click="exportCalendar">{{ $t('export') }}</el-button>
          <el-button type="primary" @click="downDetail" :loading="downLoading2">
            {{ $t('courseTask.exportDetail') }}</el-button>
        </div>
        <div class="filter-lf-bottom clearfix">
          <span class="date-title">{{ $t('courseTask.calendarTable') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 0 }]" @click="choseDateType(0)">
            {{ $t('courseTask.calendarDay') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 1 }]" @click="choseDateType(1)">
            {{ $t('courseTask.calendarWeek') }}</span>
          <span>|</span>
          <span :class="['date-tye', { 'active': dateType === 2 }]" @click="choseDateType(2)">
            {{ $t('courseTask.calendarMonth') }}</span>
        </div>
      </div>
      <div class="calendar-filter-lr clearfix">
        <div class="filter-lr-search clearfix">
          <div class="filter-module clearfix">
            <span class="filter-module-name filter-module-name2 filter-module-name3" @click="showTrainer">
              {{ $t('trainer.trainer') }}
            </span>
            <span class="filter-module-value filter-module-value2">
              <el-tooltip class="item"
                  :content="trainerSearch.trainerName"
                  :disabled="!trainerSearch.trainerName || trainerSearch.trainerName.length<6"
                   placement="top">
                  <el-input :placeholder="$t('user.select')" v-model="trainerSearch.trainerName" readonly></el-input>
              </el-tooltip>
            </span>
          </div>
          <div class="filter-module clearfix">
            <span class="filter-module-name">
              {{ $t('trainer.orgType') }}
            </span>
            <span class="filter-module-value">
              <el-select v-model="trainerSearch.orgType"
                         :placeholder="$t('res.vehinfo.select')"
                         clearable>
                <el-option v-for="(item,index) in orgTypeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="filter-module clearfix">
            <span class="filter-module-name">
              {{ $t('courseTask.startEndTime') }}
            </span>
            <span class="filter-module-value">
              <el-date-picker
                v-model="trainerSearch.time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :start-placeholder="$t('organization.startData')"
                :end-placeholder="$t('organization.endData')"
                :placeholder="$t('user.checkdate')">
              </el-date-picker>
            </span>
          </div>
          <div class="filter-module clearfix" ref="filterModule">
            <span class="filter-module-name filter-module-name3">
              {{ $t('res.coursetrainerrela.trainerfication') }}
            </span>
            <span class="filter-module-value filter-module-value2">
              <el-popover placement="bottom"
                    ref="popover"
                    :width="popWidth"
                    trigger="click">
                  <!--重置-->
                  <el-button @click="resetChecked" type="text" size="mini">{{ $t('reset') }}</el-button>
                  <el-tree style="max-height:400px; overflow-y: auto;"
                          ref="teamClassTree"
                          :data="groupList"
                          show-checkbox
                          :render-after-expand="false"
                          node-key="code"
                          :props="defaultProps"
                          @check-change="handleCheckChange"
                          :default-expand-all="true">
                  </el-tree>
                  <el-input slot="reference"
                            :placeholder="$t('user.select')"
                            clearable
                            readonly
                            v-model.trim="teamName"></el-input>
              </el-popover>
            </span>
          </div>
          <div class="filter-module clearfix">
            <span class="filter-module-name">
              {{ $t('res.coursetrainerrela.companyNameCode') }}
            </span>
            <span class="filter-module-value">
              <el-select
                  v-model="trainerSearch.queryOrgId"
                  filterable
                  remote
                  reserve-keyword
                  clearable
                  :placeholder="$t('res.coursetrainerrela.companyNameCode')"
                  :remote-method="remoteCompanyMethod"
                  :loading="companyLoading">
                  <el-option
                    v-for="(item,index) in companyOptions"
                    :key="'company'+index"
                    :label="item.abbreviationCn +'-'+item.orgCode"
                    :value="item.orgId">
                  </el-option>
                </el-select>
            </span>
          </div>
        </div>
        <div class="filter-lr-buttons">
          <el-button class="button-margin-b" type="primary" @click="searchList">
            {{ $t("query") }}
          </el-button>
          <el-button class="el-back M-margin-l" type="info" @click="resetList">
            {{ $t("reset") }}
          </el-button>
        </div>
      </div>
    </section>
    <v-gantt-chart v-loading="dataListLoading"
                    :startTime="times[0]"
                    :endTime="times[1]"
                    :tempStart="trainerSearch.startDate"
                    :cellWidth="cellWidth"
                    :cellHeight="cellHeight"
                    :timeLines="timeLines"
                    :titleHeight="titleHeight"
                    :scale="scale"
                    :titleWidth="titleWidth"
                    showCurrentTime
                    :hideHeader="false"
                    :dataKey="dataKey"
                    :arrayKeys="arrayKeys"
                    :scrollToPostion="positionB"
                    @scrollLeft="scrollLeftB"
                    customGenerateBlocks
                    :datas="datasB"
                    :queryType="queryType"
                    ref="gantChild"
                    :subHolidayList="holidayList">
        <template v-slot:block="{data,getPositonOffset,getWidthAbout2Times,isInRenderingTimeRange,
        startTimeOfRenderArea,endTimeOfRenderArea,isAcrossRenderingTimeRange}">
          <table-content :data="data"
                          :cellHeight="cellHeight"
                          :isNewScheduleModule="isNewScheduleModule"
                          :getPositonOffset="getPositonOffset"
                          :getWidthAbout2Times="getWidthAbout2Times"></table-content>
        </template>
        <template v-slot:left="{data}">
          <!--    表格左边（课程名称）      -->
          <LeftBarItem :data="data"></LeftBarItem>
        </template>
        <template v-slot:title>
          <div>
            <div class="tariner-table-lf">{{ $t('res.coursetrainerrela.trainerfication') }}</div>
            <div class="tariner-table-lr">{{ $t('offering.trainerName') }}</div>
          </div>
        </template>
    </v-gantt-chart>
    <section class="calendar-cards clearfix">
      <div class="calendar-card calendar-card1">{{ $t('courseTask.noImport') }}</div>
      <div class="calendar-card">{{ $t('courseTask.existed') }}</div>
    </section>
    <!-- 培训师选择页面 -->
    <el-dialog :title="$t('res.coursetrainerrela.alternativeTrainer')"
               :visible="isShowTrainer"
               width="90%"
               :show-close="false"
               :before-close="handleCloseTrainer">
      <trainerItem ref="trainerInfoRef"
                       v-if="isShowTrainer"
                       @onOk="onOk"
                       @closeSuboTrainerDlg="handleCloseTrainer"
                       :trainerList="trainerList"></trainerItem>
    </el-dialog>
  </div>
</template>
<script>
import vGanttChart from '@/views/modules/learning/trainerCalendar/gantt/gantt.vue';
import LeftBarItem from '@/views/modules/learning/trainerCalendar/left-bar-item/LeftBarItem.vue';
import TableContent from '@/views/modules/learning/trainerCalendar/table-content/TableContent.vue';
import trainerItem from '@/components/rm/trainer-select/index';
import dayjs from 'dayjs';
import { getDate, GetMonday, GetSunday } from '@/utils/timeLineUtils.js';

export default {
  components: {
    'v-gantt-chart': vGanttChart,
    LeftBarItem,
    TableContent,
    trainerItem
  },
  props: {
    taskId: {
      type: String
    },
    taskName:{
      type : String
    },
    taskTime: {
      type: Array
    }
  },
  data() {
    return {
      isShowTrainer: false,
      isNewScheduleModule: true,
      trainerList: [],
      orgType: this.enums['orgType'],
      orgTypeList: [],
      teamName: '',
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      popWidth: 300,
      companyLoading: false,
      companyOptions: [],
      companyTimeout: null,
      timeout: null,
      dateType: 0,
      trainerSearch: {
        trainerName: '',
        trainerIdList: [],
        orgType: '',
        time: [],
        queryOrgId: ''
      },
      // 时间线的开始结束时间
      timeLines: [
        {
          time: dayjs().add(2, 'hour').toString()
        },
        {
          time: dayjs().add(5, 'hour').toString(),
          color: '#747e80'
        }
      ],
      currentTime: dayjs(),
      cellWidth: 100, // 默认值100 在进行查询类型切换时进行更改值 月 20  周 15
      cellHeight: 38,
      titleHeight: 60,
      titleWidth: 250,
      // 时间间隔刻度 1440表示1天
      scale: 1440,
      // 设置开始和结束时间 开始时间的下标必须是0，结束是1
      times: [],
      queryType: 'day',
      cusTimes: [],
      datasB: [],
      // 组织类型
      neworgType: [],
      companyList: [],
      typeArr: this.enums['orgType'], // 所属分类
      select2: [],
      dataKey: 'trainerId',
      scrollToTime: dayjs().add(1, 'day').toString(),
      scrollToPostion: { x: 10000, y: 10000 },
      hideHeader: false,
      moreList: false,
      isShow: false,
      hideSecondGantt: false,
      showValue: '',
      showVehicleClassList: [],
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      // 等待转圈
      dataListLoading: false,
      loading: false,
      trainerShowFlg: false,
      arrayKeys: ['gtArray', 'error'],
      scrollToY: 0,
      positionB: {},
      positionA: {},
      holidayList: [],
      groupList: [],
      downLoading: false,
      downLoading2: false,
      downTimeout: null,
      downTimeout2: null
    };
  },
  methods: {
    resetList () {
      this.resetChecked();
      this.trainerSearch = {
        trainerName: '',
        queryOrgType: '',
        time: [],
        queryOrgId: ''
      };
      this.initDate();
      this.searchList();
    },
    handleCloseTrainer () {
      this.isShowTrainer = false;
    },
    showTrainer () {
      this.isShowTrainer = true;
    },
    resetChecked () {
      this.teamName = '';
      this.groupTypeList = [];
      this.$refs.teamClassTree.setCheckedKeys([]);
      this.$refs.popover.doClose();
    },
    handleCheckChange () {
      const checkedValTem = this.$refs.teamClassTree.getCheckedNodes(true, false).map((item) => {
        return item;
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.teamName = checkedValTem.map((item) => item.treamCnName).toString();
        this.groupTypeList = checkedValTem.map(item => item.id);
      }, 300);
    },
    // 远程查询所属组织
    remoteCompanyMethod (query) {
      if (query) {
        this.companyLoading = true;
        clearTimeout(this.companyTimeout);
        this.companyTimeout = setTimeout(() => {
          this.$request.get(`/sys/org/queryByOrgCodeOrName?limit=100&page=1&queryParam=${query}`).then((res) => {
            if (res) {
              this.companyLoading = false;
              this.companyOptions = res.records || [];
            }
          }).catch(() => {
            this.companyOptions = [];
            this.companyLoading = false;
          });
        }, 200);
      } else {
        this.companyOptions = [];
      }
    },
    choseDateType (val) {
      this.dateType = val;
      switch (val) {
        case 0:
          this.queryType = 'day';
          this.cellWidth = 100;
          break;
        case 1:
          this.queryType = 'week';
          this.cellWidth = 15;
          break;
        case 2:
          this.queryType = 'month';
          this.cellWidth = 10;
          break;
        default:
          break;
      }
      this.searchList();
    },
    dateFormat (date) {
      return date ? dayjs(date).format('YYYY/MM/DD HH:mm:ss') : '';
    },
    dateFormatNew (date) {
      if (new Date(date).getHours() === 9) {
        return dayjs(date).format('YYYY/MM/DD') + ' 00:00:00';
      } else if (new Date(date).getHours() === 17){
        return dayjs(date).format('YYYY/MM/DD') + ' 23:59:59';
      } else {
        return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
      }
    },
    // 培训师返回
    onOk (data) {
      const trainerName = data.map((item) => item.trainerName);
      const ids = data.map((item) => item.trainerId);
      this.trainerSearch.trainerName = trainerName.join(',');
      this.trainerSearch.trainerIdList = ids;
      this.isShowTrainer = false;
      this.trainerList = data;
    },
    // 获取数据列表
    searchList () {
      this.dataListLoading = true;
      const params = {
        taskId: this.taskId,
        trainerIdList: this.trainerSearch.trainerIdList,
        orgType: 	this.trainerSearch.orgType,
        startDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[0] + ' 00:00:00' : '',
        endDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[1] + ' 23:59:59' : '',
        orgId: 	this.trainerSearch.queryOrgId,
        groupTypeList: this.groupTypeList
      };
      this.$request.post('/classschedule/scheduleTaskResult/trainerCalendar', params).then((res) => {
        this.dataListLoading = false;
        if (res) {
          let start = res.minX;
          let end = res.maxX;
          this.times = [];
          this.holidayList = res.holidayList;
          switch (this.queryType) {
            case 'day':
              this.times.push(start, end);
              break;
            case 'week':
              start = GetMonday(getDate(start));
              end = GetSunday(getDate(end));
              this.times.push(start, end);
              break;
            case 'month':
              this.times.push(dayjs(start).format('YYYY/MM/DD'), dayjs(end).endOf('month').format('YYYY/MM/DD'));
              break;
            default:
              break;
          }
          this.datasB = res.calendarList.map((item) => {
            let gtArray = [];
            if (item.offeringCalendarTrainer) {
              gtArray  = item.offeringCalendarTrainer.map((i) => {
                i.start = i.flag === 0 ? this.dateFormatNew(i.start) : this.dateFormat(i.start);
                i.end = i.flag === 0 ? this.dateFormatNew(i.end) : this.dateFormat(i.end);
                i.startShort = i.flag === 0 ? this.dateFormatNew(i.startShort) : this.dateFormat(i.startShort);
                i.endShort = i.flag === 0 ? this.dateFormatNew(i.endShort) : this.dateFormat(i.endShort);
                return i;
              });
            }
            return { ...item, name: item.trainerName, gtArray };
          });
          this.$refs.gantChild.dateDiff(this.times[0],this.times[1]);
        }
      }).catch(() => {
        this.dataListLoading = false;
      });
    },
    initDate () {
      const start =  dayjs(this.taskTime[0]).format('YYYY-MM-DD');
      const end = dayjs(this.taskTime[1]).format('YYYY-MM-DD');
      this.trainerSearch.time = [start, end];
    },
    scrollLeftB (val) {
      this.positionA = { x: val };
    },
    getTrainerTypeList () {
      this.$request.get('/rm/rpc/treamClassTree/list?disable=false').then((res) => {
        if (res) {
          this.groupList = res;
        }
      });
    },
    downDetail () {
      clearTimeout(this.downTimeout);
      const params = {
        taskId: this.taskId,
        trainerIdList: this.trainerSearch.trainerIdList,
        orgType: 	this.trainerSearch.orgType,
        startDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[0] + ' 00:00:00' : '',
        endDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[1] + ' 23:59:59' : '',
        orgId: 	this.trainerSearch.queryOrgId,
        groupTypeList: this.groupTypeList
      };
      this.downLoading2 = true;
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/exportTrainerDetail',
        `${this.$t('courseTask.trainerDetailExport')  }_${  this.taskName  }.xls`,
        params, null, 'xls'
      );
      this.downTimeout = setTimeout(() => {
        this.downLoading2 = false;
      }, 3000);
    },
    exportCalendar () {
      clearTimeout(this.downTimeout2);
      const params = {
        taskId: this.taskId,
        trainerIdList: this.trainerSearch.trainerIdList,
        orgType: 	this.trainerSearch.orgType,
        startDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[0] + ' 00:00:00' : '',
        endDate: this.trainerSearch.time.length === 2 ? this.trainerSearch.time[1] + ' 23:59:59' : '',
        orgId: 	this.trainerSearch.queryOrgId,
        groupTypeList: this.groupTypeList
      };
      this.downLoading = true;
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      this.$request.downloadByPost7(
        '/classschedule/scheduleTaskResult/exportTrainerCalendar',
        `${this.$t('courseTask.trainerDetailExport2')  }_${  this.taskName  }.xlsx`,
        params, null, 'xlsx'
      );
      this.downTimeout2 = setTimeout(() => {
        this.downLoading = false;
      }, 4000);
    }
  },
  watch: {
    scrollToY (val) {
      this.positionA = { x: val };
    }
  },
  // 离开页面时
  beforeRouteLeave(_to, _from, next){
    this.$refs.gantChild.saveData();
		next();
  },
  mounted() {
    this.popWidth = this.$refs.filterModule.offsetWidth - 110;
    this.orgTypeList = JSON.parse(JSON.stringify(this.orgType));
    if (this.orgTypeList.length === 6) {
      this.orgTypeList.splice(3, 2);
    }
    this.getTrainerTypeList();
    this.initDate();
    this.searchList();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
    clearTimeout(this.downTimeout);
    clearTimeout(this.downTimeout2);
  }
}
</script>
<style lang="scss">
.course-result-calendar-contain {
  .calendar-filter {
    height: 80px;
    margin-bottom: 20px;
    .calendar-filter-lf {
      width: 220px;
      height: 100%;
      float: left;
      margin-right: 20px;
      .filter-lf-bottom {
        height: 46px;
        line-height: 62px;
        font-size: 16px;
        .date-title {
          margin-right: 10px;
        }
        .date-tye {
          display: inline-block;
          padding: 0 8px;
          cursor: pointer;
          &.active {
            color: #409eff;
          }
        }
      }
    }
    .calendar-filter-lr {
      float: left;
      width: calc(100% - 240px);
      height: 100%;
      .filter-lr-search {
        width: calc(100% - 90px);
        float: left;
        display: flex;
        flex-wrap: wrap;
        .filter-module {
          flex: 0 0 32%;
          margin-bottom: 12px;
          .filter-module-name {
            line-height: 34px;
            display: block;
            width: 80px;
            float: left;
            text-align: right;
            &.filter-module-name2 {
              color: #409eff;
              cursor: pointer;
              &:hover {
                opacity: .8;
                text-decoration:underline;
              }
            }
            &.filter-module-name3 {
              width: 100px;
            }
          }
          .filter-module-value {
            display: block;
            width: calc(100% - 95px);
            margin-left: 15px;
            float: left;
            &.filter-module-value2 {
              overflow: hidden;
              width: calc(100% - 115px);
            }
            .el-range-editor.el-input__inner {
              width: 100% !important;
            }
          }
        }
      }
      .filter-lr-buttons {
        float: left;
        width: 70px;
        margin-left: 20px;
        .button-margin-b {
          margin-bottom: 12px;
        }
      }
    }
  }
  .tariner-table-lf {
    width: 50%;
    float: left;
    border-right: 1px solid #dcdee3;
  }
  .tariner-table-lr {
    width: 50%;
    float: left;
  }
  .calendar-cards {
    line-height: 28px;
    margin-top: 12px;
    font-size: 14px;
    .calendar-card {
      float: left;
      height: 28px;
      border-radius: 3px;
      margin-right: 15px;
      padding: 0 10px;
      background-color: #ebecf0;
      color: #6c6a6a;
      &.calendar-card1 {
        background-color: #4bdc26;
        color: #ffffff;
      }
    }
  }
}
</style>